import {css} from 'lit'; export default css`:host{display:inherit;flex-direction:inherit}`;
    